const createFromObject = function (obj: Record<string, string | number>): string {
    const str = [];
    Object.keys(obj).map((key) => {
        obj[key] && str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    });
    const qs = str.join('&');
    return qs && `?${qs}`;
};

export default createFromObject;
